import AppInstallList from './src/app-install-list';

export default AppInstallList;
